import { Stack } from './Stack'
import Chevron from '../../../../../icons/Chevron'
import { Checkbox } from './Checkbox'
import { useState } from 'react'

export function MultiSelect({
  options,
  placeholder,
  id,
  label = 'Velg...',
  handleChange,
  isOpen: controlledIsOpen,
  onOpenChange,
}: {
  label?: string
  id: string
  options: {
    value: string
    label: string
    price?: string
    isChecked?: boolean
  }[]
  placeholder: string
  handleChange: (value: string) => void
  isOpen?: boolean
  onOpenChange?: (open: boolean) => void
}) {
  const [internalOpen, setInternalOpen] = useState(false)
  const findSelectedOptions = options.filter((option) => option.isChecked)
  const open = controlledIsOpen ?? internalOpen

  function setOpen(nextOpen: boolean) {
    if (controlledIsOpen === undefined) {
      setInternalOpen(nextOpen)
    }

    onOpenChange?.(nextOpen)
  }

  return (
    <Stack spacing="flush">
      <label className="font-semibold pb-1" htmlFor={id}>
        {label}
      </label>
      <div>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="flex relative bg-white text-sm border-[#D9D9D9] border-[2px] pl-3 pr-2 rounded-lg justify-between items-center text-gray-500 gap-2 w-full min-h-[38px]"
        >
          <div className="flex flex-row text-black items-center gap-1 whitespace-nowrap overflow-hidden min-w-0 w-full">
            {findSelectedOptions.length === 0 && <p className="text-gray-400 truncate">{placeholder}</p>}
            {findSelectedOptions.slice(0, 2).map((item, index) => {
              const isLast = index >= 1 || index === findSelectedOptions.length - 1

              return (
                <p key={item.value} className="truncate">
                  {item.label}
                  {!isLast && ','}
                </p>
              )
            })}
            {findSelectedOptions.length > 2 && <span className="text-gray-400 shrink-0">+ {findSelectedOptions.length - 2} til</span>}
          </div>
          <Chevron rotated className="text-black" />
        </button>
        {open && (
          <div className="border-[1px] z-[22] mt-2 max-h-[250px] bg-white overflow-y-auto rounded-md flex flex-col items-start">
            {options.map((option) => {
              return (
                <button
                  type="button"
                  className="w-full [data-dropdown] capitalize text-sm flex justify-between rounded-md items-center gap-2 hover:bg-gray-100 transition-all ease-in-out text-left px-3 py-3"
                  onClick={() => handleChange(option.value)}
                  key={option.value}
                >
                  <div className="flex items-center gap-2">
                    <Checkbox checked={option.isChecked} />
                    {option.label}
                  </div>
                  <p className=" place-content-end">{option?.price}</p>
                </button>
              )
            })}
          </div>
        )}
      </div>
    </Stack>
  )
}
